exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".overview-table {\n\ttop: 62px !important;\n}\n\n.overview-table.has-guide {\n\ttop: 161px !important;\n}\n\n.overview-table .slds-page-header, .sources-empty .slds-page-header {\n\tbackground: #fafaf9;\n\tborder-bottom: 0;\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.overview-table__status-cell svg {\n\tmargin: -2px 2px 0;\n\twidth: 8px;\n}\n.overview-table__status-cell svg.help {\n\tmargin-left: 6px;\n\twidth: 12px;\n}\n\n.overview-table .slds-notify-container {\n\theight: 0;\n\toverflow: hidden;\n\tposition: absolute;\n\t-webkit-transition: height 0.5s;\n\t-o-transition: height 0.5s;\n\ttransition: height 0.5s;\n}\n\n.overview-table .slds-notify-container.open {\n\theight: 64px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/lib/Overview/overview.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/lib/Overview/overview.css
// module chunks = 0